import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import moment from 'moment';
import { AssignmentType, ExpectationUnit, ScoreVisibilityType } from '@module/assignment';
export function getCreateAssignmentFormValuesForType(_ref) {
  var type = _ref.type,
      title = _ref.title,
      _ref$securityOptions = _ref.securityOptions,
      securityOptions = _ref$securityOptions === void 0 ? [] : _ref$securityOptions,
      _ref$defaultTermsAndC = _ref.defaultTermsAndConditions,
      defaultTermsAndConditions = _ref$defaultTermsAndC === void 0 ? '' : _ref$defaultTermsAndC;

  var shared = _objectSpread(_objectSpread({
    permission: {
      mode: 'global',
      classIds: [],
      userIds: []
    },
    type: type
  }, title ? {
    title: title
  } : {}), {}, {
    description: undefined,
    hasPassword: false,
    password: undefined,
    isShuffleQuestion: false,
    isShuffleAnswer: false,
    duration: 30,
    isShowingExplanationAndCorrectAnswers: true,
    isShowingScore: true,
    expectation: 50,
    expectationType: ExpectationUnit.Percentage
  });

  if (type === AssignmentType.Practice) {
    return _objectSpread(_objectSpread({}, shared), {}, {
      rangeDate: undefined,
      isUnlimitedAvailability: true,
      isUnlimitedNumberOfSubmission: true,
      numberOfSubmission: -1,
      scoreVisibilityType: undefined,
      hasSecurityOptions: false,
      securityOptionIds: undefined,
      shouldAutoBan: false,
      maximumFoulsAllowed: undefined,
      termsAndConditions: undefined
    });
  }

  if (type === AssignmentType.Examination) {
    return _objectSpread(_objectSpread({}, shared), {}, {
      rangeDate: [moment().add(10, 'minutes'), moment().add(40, 'minutes')],
      scoreVisibilityType: ScoreVisibilityType.manualPublishScore.value,
      hasSecurityOptions: false,
      securityOptionIds: securityOptions.map(function (option) {
        return option.id.toString();
      }),
      shouldAutoBan: false,
      maximumFoulsAllowed: undefined,
      termsAndConditions: defaultTermsAndConditions,
      numberOfSubmission: undefined
    });
  }

  return shared;
}